import { SpinnerIcon } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';

export function PricelistSidebarActionButton({
  icon,
  busy = false,
  disabled = false,
  onClick,
  children,
}: {
  icon: React.ReactNode;
  busy?: boolean;
  disabled?: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <Button
      variant="outline"
      className="w-full justify-start"
      disabled={disabled || busy}
      onClick={onClick}
    >
      {busy ? <SpinnerIcon className="h-4 w-4 animate-spin" /> : icon}
      {children}
    </Button>
  );
}
